export function arc(ctx) {
    return {
        styles: {
            main:      { ...ctx.pretty, radius: 4, line_color: ctx.COLOR_BG_SEC, line_width: 15 },  // #d4d7d9 arc BG track = COLOR_BG_SEC light
            indicator: { line_color: ctx.primary, line_width: 15, line_rounded: true },
            knob:      { bg_color: ctx.COLOR_BG, padding: 0, border_width: 0, border_color: ctx.COLOR_BG_BORDER },  // arc knob = COLOR_BG light = #ffffff
        },
    };
}
